<template>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="60%">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="billno" label="关联订单" min-width="100"> </el-table-column>

            <el-table-column prop="coupon_name" label="使用优惠券名称" min-width="100"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="使用时间" min-width="140"> </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
let _this;
export default {
    props: {
        isShow: Boolean,
        children_data: '',
        consumer_code: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data.package_code = _this.children_data;
            _this.search_data.consumer_code = _this.consumer_code;

            _this.useCouponPackageLog();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,

            search_data: {
                page: 1,
                limit: 10,
                package_code: '',
                consumer_code: ''
            },

            tableData: [],
          
        };
    },
    methods: {
        useCouponPackageLog() {
            _this.$post('/package/useCouponPackageLog', _this.search_data).then((res) => {
             
                _this.tableData = res.data;
                console.log(_this.tableData, '_this.tableData');
            });
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
</style>
